// Unpublished Work © 2026 Deere & Company.

import {INVALID_RESPONSE_CODE} from '../constants/error-messages';
import {UserType} from '../types/user-type';

export async function getIsEmployee(): Promise<boolean> {
    try {
        const result = await fetch('/api/user-type');

        if (!result.ok) {
            throw new Error(INVALID_RESPONSE_CODE);
        }

        const userType: UserType = await result.json();

        return userType.isEmployee === true;
    } catch {
        return false;
    }
}
